import angular from 'angular';
import { EmployeeWorkOrderListModalComponent } from './employee-work-order-payout/employee-work-order-list-modal.component';
import { EmployeeWorkOrderProductOrderListComponent } from './employee-work-order-payout/employee-work-order-product-order-list.component';
import { EmployeeWorkOrderProductOrdersModalComponent } from './employee-work-order-payout/employee-work-order-product-orders-modal.component';
import { EmployeeWorkOrderListComponent } from './employee-work-order-payout/employee-work-order-list.component';
import { IcdPostedPayoutDetailReportComponent } from './icd-posted-payout-detail-report/icd-posted-payout-detail-report.component';
import { IcdWorkOrderPayoutBreakdownComponent } from './icd-work-order-payout-breakdown/icd-work-order-payout-breakdown.component';

/**
 * A module containing payout reports in formats containing information that is
 * universal to all divisions.
 */
export const PayoutReportCommonModule = angular
    .module("apex.mainApp.payout.report.common", [])
    .component("apexEmployeeWorkOrdersListModal", EmployeeWorkOrderListModalComponent)
    .component("apexEmployeeWorkOrderProductOrderList", EmployeeWorkOrderProductOrderListComponent)
    .component("apexEmployeeWorkOrderProductOrdersModal", EmployeeWorkOrderProductOrdersModalComponent)
    .component("apexEmployeeWorkOrderList", EmployeeWorkOrderListComponent)
    .component("apexIcdPostedPayoutDetailReport", IcdPostedPayoutDetailReportComponent)
    .component("apexIcdWorkOrderPayoutBreakdown", IcdWorkOrderPayoutBreakdownComponent)
    .name;
